import type { ChartTypeId } from './registry';

/**
 * Metric → conventional chart defaults, applied ONCE when the wizard opens a
 * fresh chart (the "instant chart on open" auto-config). The detected metric of
 * the suggested Y column picks the clinical chart type + its conventional scale
 * so the modal opens showing a finished chart the professional tweaks instead
 * of builds.
 *
 * This is the only place a scale is prefilled — the gallery itself is a pure
 * chart-type picker (a card sets the type only). Per project decision, bands and
 * cutoff lines are NEVER prefilled; only type + scale.
 */
export interface MetricChartDefault {
    chartType: ChartTypeId;
    axis?: { min?: number; max?: number };
    lineStyle?: { curve: 'straight' | 'smooth'; fill: boolean };
}

export const METRIC_CHART_DEFAULTS: Record<string, MetricChartDefault> = {
    percentile: { chartType: 'bar', axis: { min: 0, max: 100 } },
    t: {
        chartType: 'line',
        axis: { min: 20, max: 80 },
        lineStyle: { curve: 'straight', fill: false },
    },
    scaled10_3: {
        chartType: 'line',
        axis: { min: 0, max: 19 },
        lineStyle: { curve: 'straight', fill: false },
    },
};
